import { isNull } from 'lodash';
import dayjs from 'dayjs';

import { setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { UserGradeResponseType } from './types';

export const getStandardDescription = (min: number | null, max: number | null, unit: string): string => {
  if (isNull(min) && isNull(max)) return '-';

  return isNull(min)
    ? `${setNumberWithComma(max, unit)} 미만`
    : isNull(max)
      ? `${setNumberWithComma(min, unit)} 이상`
      : `${setNumberWithComma(min, unit)} 이상 ${setNumberWithComma(max, unit)} 미만`;
};

/**
 * 등급 산정 시작 날짜 구하는 함수
 * @param {string} createDate - 등급 생성 날짜
 * @param {number} periodMonth - 등급 산정 기간(개월 수)
 * @returns {string} 현재 달의 이전달(ex. 3월이면 2월)부터 api에서 내려주는 periodMonth만큼 제외한 달(periodMonth가 6이면 2 - 6인 8월)의 1일을 22.08.01의 형식으로 리턴
 * */
export const gradeCreateFromDate = (createDate: string, periodMonth: number): string =>
  setDateFormat(dayjs(createDate).subtract(periodMonth, 'month').startOf('month'), DATE_FORMAT.YMD_DOT_FORMAT);

export const gradeCreateToDate = (createDate: string): string =>
  setDateFormat(dayjs(createDate).subtract(1, 'month').endOf('month'), DATE_FORMAT.YMD_DOT_FORMAT);

export const getStandardMinMax = (
  grades: UserGradeResponseType[],
  currentGrade: UserGradeResponseType,
  key: 'purchaseAmount' | 'purchaseCount',
): { min: number | null; max: number | null } => {
  const nextGrade = grades?.find((item) => currentGrade.grade + 1 === item.grade);
  const prevGrade = grades?.find((item) => currentGrade.grade - 1 === item.grade);

  return {
    min: prevGrade ? currentGrade[key] : null,
    max: nextGrade ? nextGrade[key] : null,
  };
};
